import { ApprovalRemindersWidget } from '@components/Dashboard/ApprovalRemindersWidget';
import { DeadlineSummariesWidget } from '@components/Dashboard/DeadlineSummariesWidget';
import { StatsCards } from '@components/Dashboard/StatsCards';
import { PendingItemsSummary } from '@components/Dashboard/PendingItemsSummary';
import { UpcomingDiscountDeadlines } from '@components/Dashboard/UpcomingDiscountDeadlines';
import { CustomDashboards } from '@components/Dashboard/analytics/CustomDashboards';
import UsageBar from '@components/common/UsageBar';

export const DashboardPage = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-50 mb-2">Dashboard</h1>
        <p className="text-gray-600 dark:text-gray-400">Welcome to AP Automation</p>
      </div>

      <CustomDashboards />

      <UsageBar />

      <StatsCards />

      <UpcomingDiscountDeadlines />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <DeadlineSummariesWidget />
        <ApprovalRemindersWidget />
      </div>
      <PendingItemsSummary />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          {/* <PendingItemsSummary /> */}
        </div>
        {/* <div className="bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/20 rounded-lg p-6 border border-primary-200 dark:border-primary-800">
          <h3 className="font-semibold text-primary-900 dark:text-primary-100 mb-2">Quick Tips</h3>
          <ul className="space-y-2 text-sm text-primary-800 dark:text-primary-200">
            <li>• Upload POs, Receipts, and Invoices from the Documents page</li>
            <li>• Review documents with low confidence scores</li>
            <li>• Check matching results and AP entries</li>
            <li>• Confidence threshold: 90%</li>
          </ul>
        </div> */}
      </div>
    </div>
  );
};
